<template>
    <div class="footer-section">
        <div class="container">
            <article>
                <div class="footer-message" v-html="footermessage"></div>
                <div class="copyright">
                    <p><sup>©</sup>&nbsp;Elan Financial Services</p>
                </div>
            </article>
        </div>
    </div>
</template>

<script>
export default {
    props:['footermessage']
}
</script>

<style lang="scss">
    .footer-section {
        background-color: #000000;
        color:#ffffff;
        padding:20px;
        font-family: Arial, sans-serif;
        font-size:12px;

        a {
            &:link, &:visited {
                color:#ffffff;
            }

            &:hover, &:active {
                text-decoration:none !important;
            }
        }
    }

    .footer-section div, .footer-section p, .footer-message p{
        color:#ffffff;
        font-family: Arial, sans-serif;
    }

</style>
